<template>
  <div class="background py-3">
    <template v-for="search in results">
      <search-card disabled :search="search" class="mb-3"></search-card>
    </template>
  </div>
</template>

<script>
import { UserResults } from "@/graphql/queries/searches";
import SearchCard from "@/components/searches/Card";

export default {
  data: () => ({
    results: []
  }),

  created() {
    this.fetchResults();
  },

  methods: {
    fetchResults() {
      this.$apollo
        .query({
          query: UserResults,
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.results = res.data.userResults;
        });
    }
  },

  components: {
    SearchCard
  }
};
</script>
